var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0 px-4 pb-4 pb-md-10 px-md-0"},[_c('v-row',_vm._l((_vm.articles),function(article,index){return _c('v-col',{key:index,staticClass:"pb-0 d-flex mt-1",attrs:{"cols":"12","sm":"6","md":"6","lg":"4"}},[_c('ModalPostDetail',{staticClass:"flex-grow-1",attrs:{"article":article}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }